import { yupResolver } from '@hookform/resolvers/yup';
import React, { useContext, useReducer } from 'react';
import { useHistory } from 'react-router';
// import { Link } from 'react-router-dom';
import { uid } from 'uid';
// import { IoCloseSharp } from 'react-icons/io5';
import { Controller, useForm } from 'react-hook-form';
import * as yup from 'yup';
// import axios from 'axios';
import { getRequiredErrorMessage } from '../../../../utils/common.utils';
import { PropsFromRedux } from '.';
import TextInput from '../../../form-controls/TextInput';
import { ReactComponent as List } from '../../../../assets/images/receiver-list.svg';
import PersonalShopperContext from '../../../../context/PersonalShopperContex/PersonalShopperContex';
import styles from './AddShopperItem.module.scss';

interface Props extends PropsFromRedux {}

interface Inputs {
  ProductLink: string;
  ItemName: string;
  Quantity: number;
  Description: string;
}

const schema = yup.object().shape({
  ItemName: yup.string().required(getRequiredErrorMessage('Item Name')),
  Description: yup.string().required(getRequiredErrorMessage('Description')),
  Quantity: yup.number().required(getRequiredErrorMessage('Quantity')),
  ProductLink: yup.string().required(getRequiredErrorMessage('Product Link')),
});

export const AddShopperItem: React.FC<Props> = ({
  resetApi,
  showModal,
  hideModal,
  receiverState,
}) => {
  const closeModal = () => {
    hideModal();
  };

  const { shopperData, setShopperData } = useContext(PersonalShopperContext);

  // console.log('shopper data -->' , shopperData);

  const [updatedValue, forceUpdate] = React.useReducer((x) => x + 1, 0);

  const [addItemId, setAddItemId] = React.useState(null);

  const history = useHistory();

  const receiverList = receiverState?.response?.Object;

  const [receiver, setReceiver] = React.useState({});

  const onSubmit = async (data: Inputs) => {
    const shopperDetails = shopperData;
    const allItem = [];
    let items = [];
    items = shopperDetails.ShoppingItem;

    const ItemDetails = {
      Quantity: data.Quantity,
      itemId: uid(8),
      ItemName: data.ItemName,
      Description: data.Description,
      ProductLink: data.ProductLink,
    };
    allItem.push(...items, ItemDetails);

    // console.log('All item', allItem);
    shopperDetails.ShoppingItem = allItem;
    // shopperDetails.Items = allItem;
    setShopperData(shopperDetails);
    // localStorage.setItem('itemstatus', 'added');
    // history.push('/shopping-summary');
    // console.log('Shopper details',shopperDetails);
    hideModal();
  };

  // console.log('Shopper second',shopperData);

  const { handleSubmit, control, errors, reset, watch, register, setValue } =
    useForm<Inputs>({
      resolver: yupResolver(schema),
    });

  const deliveryMethod: any = watch('DeliveryMethod');

  return (
    <form className="w-full" onSubmit={handleSubmit(onSubmit)}>
      <div className="w-full mx-auto max-w-md">
        <h2 className="font-bold text-xl text-center my-6 mb-8">
          Personal Shopping
        </h2>
        <div className="w-full mb-5 text-sm text-gray-500 font-medium">
          <Controller
            name="ProductLink"
            control={control}
            defaultValue=""
            render={({ name, value, onChange }) => (
              <TextInput
                name={name}
                value={value}
                className="border-gray-300 border p-3 w-full rounded-md"
                id={name}
                labelClassName="mb-2 flex "
                label="Paste Product Link"
                type="string"
                wrapperClassName="w-full"
                error={errors['ProductLink']}
                placeholder="Paste Link"
                customChange={onChange}
              />
            )}
          />
        </div>
        <div className="mb-5 text-sm text-gray-500 font-medium">
          <Controller
            name="ItemName"
            control={control}
            defaultValue=""
            render={({ name, value, onChange }) => (
              <TextInput
                name={name}
                value={value}
                className="border-gray-300 border p-3 w-full rounded-md"
                id={name}
                labelClassName="mb-2 flex "
                label="Item Name"
                type="string"
                wrapperClassName="w-full"
                error={errors['ItemName']}
                placeholder="A brown nike shoe"
                customChange={onChange}
              />
            )}
          />
        </div>
        <div className="mb-5 text-sm text-gray-500 font-medium">
          <Controller
            name="Quantity"
            control={control}
            render={({ name, value, onChange }) => (
              <TextInput
                name={name}
                value={value}
                className="border-gray-300 border p-2 w-full rounded"
                id={name}
                labelClassName="mb-2 flex text-sm text-gray-500 font-medium "
                label="Quantity"
                type="text"
                wrapperClassName="w-full"
                error={errors['Quantity']}
                placeholder="Quantity"
                customChange={onChange}
              />
            )}
          />
        </div>

        <div className="mb-5 text-sm text-gray-500 font-medium">
          <Controller
            name="Description"
            control={control}
            defaultValue=""
            render={({ name, value, onChange }) => (
              <TextInput
                name={name}
                value={value}
                className="border-gray-300 border p-3 w-full rounded-xl"
                id={name}
                labelClassName="mb-2 ml-2 flex"
                label="Description"
                type="text"
                multiline
                rows={3}
                wrapperClassName="w-full"
                error={errors['Description']}
                placeholder="eg. Color , texture, Fabric (Max 150 character)"
                customChange={onChange}
              />
            )}
          />
        </div>

        <div className="w-full p-4 border border-grey-300 rounded-sm">
          <div className="flex justify-between ">
            <List className="" />
            <div className="">
              <h5 className="font-medium text-sm font-semibold">
                Receiver’s Details
              </h5>
              <div className="w-full">
                <p className="text-gray-400 text-xs">
                  {shopperData?.Receiver?.FullName}
                </p>
                <p className="text-gray-400 text-xs">
                  {shopperData?.Receiver?.Address}
                </p>
              </div>
            </div>
            {receiverList?.length > 0 && (
              <button
                type="button"
                className={`w-32 p-2 h-8 rounded-full text-center py-2 mx-12 text-xs text-white ${styles.btn}`}
                onClick={() => {
                  showModal({
                    component: 'ReceiverList',
                    modalProps: {
                      contentLabel: 'Receiver List',
                    },
                    ownProps: {
                      addreceiver: 'addreceiver',
                    },
                  });
                }}
              >
                Change Receiver
                {/* className={styles.btn}  */}
              </button>
            )}
          </div>
        </div>

        <button
          className="w-full bg-secondary my-10 font-semibold text-sm rounded text-white py-4"
          type="submit"
          // disabled={validationState?.loading}
        >
          Proceed
        </button>
      </div>
    </form>
  );
};
